export var PspIdentifierType = /* @__PURE__ */ ((PspIdentifierType2) => {
  PspIdentifierType2["Bic"] = "Bic";
  PspIdentifierType2["Other"] = "Other";
  return PspIdentifierType2;
})(PspIdentifierType || {});
